<template>
  <v-card-subtitle :class="customClass" :data-cy="dataCy">
    <v-tooltip bottom :disabled="!tooltipText">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <span> {{ label }}: </span>
          <span class="value">
            {{ formattedText }}
          </span></span
        >
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-card-subtitle>
</template>

<script>
export default {
  props: {
    value: String,
    label: String,
    invalidText: String,
    customClass: String,
    tooltipText: String,
    dataCy: String,
  },
  computed: {
    formattedText() {
      const noTS = this.invalidText || this.$t('map.popover.notApplicable')
      return this.value || noTS
    },
  },
}
</script>
